import { forwardRef, HTMLAttributes, useEffect, useRef } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'
import { gsap } from 'gsap'

export type AudioIconProps = HTMLAttributes<HTMLButtonElement> & {
  muted?: boolean
}

const AudioIcon = forwardRef<HTMLButtonElement, AudioIconProps>(({ muted, ...props }, ref) => {
  const wave = useRef<SVGPolylineElement>(null!)
  const angle = useRef(0)
  const amplitude = useRef({ value: muted ? 0.3 : 1.5 })
  const frequency = 5
  const speed = 0.08

  useIsomorphicLayoutEffect(() => {
    const tick = () => {
      let points = ''
      angle.current += speed
      for (let x = 0; x < 1; x += 1 / 7) {
        points += ''
          .concat((1 + 8 * x).toFixed(2), ',')
          .concat(
            (5 + Math.sin(x * frequency + angle.current) * amplitude.current.value).toFixed(2),
            ' '
          )
      }
      wave.current.setAttribute('points', points)
    }

    gsap.ticker.add(tick)

    return () => {
      gsap.ticker.remove(tick)
    }
  })

  useEffect(() => {
    gsap.to(amplitude.current, {
      value: muted ? 0.3 : 1.5,
      duration: 0.8,
      ease: 'power2.out'
    })
  }, [muted])

  return (
    <button ref={ref} aria-label="toggle-audio" {...props}>
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 10 10"
        className="fill-none stroke-current stroke-1"
      >
        <polyline ref={wave} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  )
})

export default AudioIcon
